
import { mapGetters } from 'vuex'
import { orderStatusBySeller } from '@/enum/localEnum'
import PackageTable from '@/components/release/PackageTable'
import PackageDialog from '@/components/release/PackageDialog'
import { copyToClip } from '~/utils/index'
import RightButtons from '@/components/PZRightButtons'
const SellerDetailsSetStand = () => import('@/components/SellerDetails/setStand')
import TitleBox from '@/components/CSS/TitleBox'
export default {
    components: {
        PackageTable,
        PackageDialog,
        TitleBox,
        RightButtons
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo'
        }),
        // 头部按钮配置
        buttonList() {
            const buttons = []

            const downSelf = {
                text: '下架商品',
                handler:  () => this.updateGoodsStatusHandle(this.orderStatusBySeller.ONESELF_DOWN_STAND)
            }
            const editPrice = {
                text: '改价/库存',
                handler:  this.onEditSpu,
                primary: true
            }

            const deleteGoods = {
                text: '删除商品',
                handler:  this.deleteGoodsHandler
            }
            const upSelf = {
                text: '上架商品',
                handler:  () => this.updateGoodsStatusHandle(this.orderStatusBySeller.ON_STAND)
            }

            // 根据商品状态配置按钮
            // switch (this.status) {
            //     case this.orderStatusBySeller.ON_STAND: // 在售
            //         buttons.push(
            //             {
            //                 key: 'down-shelf',
            //                 text: '下架商品',
            //                 class: '',
            //                 handler: () => this.updateGoodsStatusHandle(this.orderStatusBySeller.ONESELF_DOWN_STAND)
            //             },
            //             ...(!this.goodsDetail?.needSku ? [{
            //                 key: 'edit-price',
            //                 text: '改价/库存',
            //                 class: 'red-btn',
            //                 handler: this.onEditSpu
            //             }] : []),
            //         )
            //         break

            //     case this.orderStatusBySeller.WAIT_VERIFY: // 待审核
            //         break

            //     case this.orderStatusBySeller.FORCE_DOWN_STAND: // 强制下架
            //         buttons.push(
            //             {
            //                 key: 'delete-goods',
            //                 text: '删除商品',
            //                 class: '',
            //                 handler: this.deleteGoodsHandler
            //             }
            //         )
            //         break

            //     case this.orderStatusBySeller.VERIFY_FAIL: // 审核失败
            //         buttons.push(
            //             {
            //                 key: 'delete-goods',
            //                 text: '删除商品',
            //                 class: '',
            //                 handler: this.deleteGoodsHandler
            //             }
            //         )
            //         break

            //     case this.orderStatusBySeller.ONESELF_DOWN_STAND: // 自主下架
            //         buttons.push(
            //             {
            //                 key: 'up-shelf',
            //                 text: '上架商品',
            //                 class: '',
            //                 handler: () => this.updateGoodsStatusHandle(this.orderStatusBySeller.ON_STAND)
            //             },
            //             ...(!this.goodsDetail?.needSku ? [] : [{
            //                 key: 'edit-price',
            //                 text: '改价/库存',
            //                 class: 'red-btn',
            //                 handler: this.onEditSpu
            //             }]),
            //             {
            //                 key: 'delete-goods',
            //                 text: '删除商品',
            //                 class: '',
            //                 handler: this.deleteGoodsHandler
            //             }
            //         )
            //         break

            //     case 'WAIT_PUBLISH': // 待发布
            //         buttons.push(
            //             {
            //                 key: 'delete-goods',
            //                 text: '删除商品',
            //                 class: '',
            //                 handler: this.deleteGoodsHandler
            //             }
            //         )
            //         break

            //     default:
            //         break
            // }

            switch (this.status) {
                case this.orderStatusBySeller.ON_STAND: // 在售
                    buttons.push(downSelf)
                    if(!this.goodsDetail?.needSku) {
                        buttons.push(editPrice)
                    }
                    break;
                case this.orderStatusBySeller.WAIT_VERIFY: // 待审核
                    break
                case this.orderStatusBySeller.FORCE_DOWN_STAND: // 强制下架
                case this.orderStatusBySeller.VERIFY_FAIL: // 审核失败
                case this.orderStatusBySeller.WAIT_PUBLISH: // 待发布
                    buttons.push(deleteGoods)
                    break
                case this.orderStatusBySeller.ONESELF_DOWN_STAND: // 自主下架
                    buttons.push(upSelf)
                    if(!this.goodsDetail?.needSku) {
                        buttons.push(editPrice)
                    }
                    buttons.push(deleteGoods)
                    break
                default:
                    break
            }

            return buttons
        },
        price() {
            // 多个sku展示 ￥:最小值-最大值 单个直接展示价格
            if (this.skuList?.length > 1) {
                let minPrice = null
                let maxPrice = null
                this.skuList.forEach(item => {
                    if (minPrice === null || item.skuPrice < minPrice) {
                        minPrice = item.skuPrice
                    }
                    if (maxPrice === null || item.skuPrice > maxPrice) {
                        maxPrice = item.skuPrice
                    }
                })
                return minPrice === maxPrice ? `${minPrice}` : `${minPrice}-${maxPrice}`
            } else {
                return `${this.goodsDetail?.price || '--'}`
            }
        },
        stock() {
            if (this.skuList?.length > 1) {
                return this.skuList.reduce((total, item) => item.enable ? total + item.skuStock : total, 0)
            } else {
                return this.goodsDetail?.stock || 0
            }
        },
        canEditSkus() {
            return [this.orderStatusBySeller.ON_STAND, this.orderStatusBySeller.ONESELF_DOWN_STAND].includes(this.status)
        }
    },
    data() {
        return {
            income: 0,
            serviceCharge: 0,
            orderStatusBySeller,
            loading: true,
            goodsNo: null,
            gameId: null,
            goodsCatalogueId: null,
            goodsSubCatalogueId: null,
            goodsDetail: null,
            status: null,
            skuList: [],
            sellerInfo: {},
            selectPackageIndex: 0,
            skuForm: {},
            feeDataList: [],
            skuConfig: [], // 套餐配置
            spuConfig: [], // 商品配置
            attrsConfig: [], // 商品属性配置
            detailsImages: [], // 商品详情图
            description: '',
            goodsInfo: [], // 商品信息
        }
    },
    mounted() {
        this.onInit()
    },
    methods: {
        // 返回
        back() {
            this.$router.push({
                path: '/account/sellerList',
                query: { status: this.$route.query.status }
            })
        },
        async onInit() {
            this.goodsNo = this.$route.query.goodsNo
            this.gameId = this.$route.query.gameId
            this.goodsCatalogueId = this.$route.query.goodsCatalogueId || 6
            this.goodsSubCatalogueId = this.$route.query.goodsSubCatalogueId || null
            await this.getGeneralGoodsSpuDetail()
            if (this.goodsDetail?.needSku) {
                this.getGeneralGoodsSkuDetail()
            }
            this.getGeneralGoodsSellerInfo()
            this.getFeeData()
        },
        // 获取商品详情
        async getGeneralGoodsSpuDetail() {
            const p = {
                goodsNo: this.goodsNo
            }
            const res = await this.$api.getGeneralGoodsSpuDetail(p)
            this.loading = false
            if (!res.success) {
                this.loading = false
                this.$message.error(res.info)
                return
            }

            this.goodsDetail = res.data
            if (res.data.goodsImg) {
                this.goodsDetail.goodsImg = this.goodsDetail.goodsImg && this.goodsDetail.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
            }
            this.status = res.data.status
            const propertyConfigVOS = res.data.propertyConfigVOS;
            if (propertyConfigVOS.length) {
                this.goodsInfo = []
                this.description = ''
                this.detailsImages = []
                propertyConfigVOS.forEach(item => {
                    const { mappingField, propertyName, value, values } = item;
                    switch (mappingField) {
                        case 'description':
                            this.description = value || '';
                            break;
                        case 'detailsImages':
                            this.detailsImages = values || [];
                            break;
                        default:
                            this.goodsInfo.push({
                                propertyName,
                                value: values?.length ? values.join('、') : value.replace(/P!Z!/g, '/'),
                                action: mappingField === 'goodsNo' ? 'copy' : ''
                            });
                            break;
                    }
                });
            }
            // 没有套餐的时候 计算代售费和收益
            if (this.goodsDetail.price && !this.goodsDetail.needSku) {
                this.calculateFees()
            }
        },
        // 计算代售费和收益
        async calculateFees() {
            const params = {
                action: {
                    gameId: this.gameId,
                    goodsCatalogueId: this.goodsCatalogueId,
                    goodsSubCatalogueId: this.goodsSubCatalogueId,
                    goodsNo: this.goodsNo,
                    goodsPrice: Number(this.goodsDetail.price)
                }
            }
            try {
                const res = await this.$api.getBargainFee(params)
                if (res.success) {
                    this.serviceCharge = res.data.serviceFee
                    this.income = parseFloat(Number(this.goodsDetail.price) - res.data.serviceFee).toFixed(2)
                }
            } catch (error) {
                console.error('计算代售费失败:', error)
            }
        },
        // 获取商品SKU详情
        async getGeneralGoodsSkuDetail() {
            const queryAllStatus = [this.orderStatusBySeller.WAIT_VERIFY, this.orderStatusBySeller.VERIFY_FAIL].includes(this.status);
            const p = {
                goodsNo: this.goodsNo,
                queryAllStatus
            }
            const res = await this.$api.getGeneralGoodsSkuDetail(p)
            this.skuList = res.data || []
        },
        // 获取卖家信息
        async getGeneralGoodsSellerInfo() {
            const p = {
                goodsNo: this.goodsNo
            }
            const res = await this.$api.getGeneralGoodsSellerInfo(p)
            this.sellerInfo = res.data || {}
        },
        async getFeeData() {
            // 获取服务费
            let data = {
                action: {
                    gameId: this.gameId,
                    goodsCatalogueId: this.goodsCatalogueId,
                    goodsSubCatalogueId: this.goodsSubCatalogueId,
                    goodsNo: this.goodsNo
                }
            }
            const res = await this.$api.getFeeNew(data)
            if (res.success) {
                this.feeDataList = res.data
            }
        },
        /**
         * 检查是否被限制强制下架商品
         */
        async onCheckLimit() {
            const par = {
                action: {
                    userBizLimited: 'GOODS_FORCE_DOWN_STAND'
                }
            }
            const check = await this.$api.checkOrderLimit(par)
            if (!check.data) {
                this.$message.error(check.info)
                return false
            }
            return true
        },
        /**
         * 修改商品状态
         * 做下架、上架等操作
         */
        updateGoodsStatusHandle(status) {
            let message =  `确定要下架【${this.goodsDetail?.title.length > 15 ? this.goodsDetail?.title.substring(0, 15) + '...' : this.goodsDetail?.title}】商品吗`
            const model = this.$pzDialog(
                {
                    width: '600px',
                    title: '提示',
                    component: SellerDetailsSetStand,
                    showFooter: false,
                    componentData: {
                        goodsDetails: this.goodsDetail,
                        msg: message
                    },
                    onConfirm: async e => {
                        const loading = this.$loading({
                            lock: true,
                            text: '处理中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        })
                        const p = {
                            goodsNo: this.goodsNo,
                            status
                        }
                        if (e?.checked) {
                            p.action.refundFeelRelieved = true
                        }
                        const check = await this.onCheckLimit()
                        if (!check) { return }

                        this.$api.onGeneralGoodsStatusUpdate(p).then(res => {
                            loading.close()
                            if (!res.success) {
                                this.$message.error(res.info)
                                return
                            }
                            this.$message.success(res.info || '操作成功')
                            VBus.$emit('reload')
                            this.$router.push({
                                path: '/account/sellerList',
                                query: { status: this.$route.query.status }
                            })
                        })
                        model.remove()
                    },
                    onCancel: async () => {
                        model.remove()
                    }
                },
                this
            )
        },

        /**
         * 删除
         */
        deleteGoodsHandler() {
            let conformMsg = '您确定要删除该商品吗？'
            if (this.goodsDetail?.status === 'ONESELF_DOWN_STAND') {
                conformMsg = '确认后，当前商品将会删除，若您已购买极速卖权益，也将同步取消'
            }
            this.$confirm(conformMsg, '警告', {
                confirmButtonText: '确定',
                confirmButtonClass: 'confirmButtonClass',
                type: 'error'
            })
                .then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: '处理中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    const p = {
                        goodsNo: this.goodsNo
                    }
                    this.$api.onGeneralGoodsDelete(p).then(res => {
                        loading.close()
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.$message.success(res.info || '删除成功')
                        VBus.$emit('reload')
                        this.$router.push({
                            path: '/account/sellerList',
                            query: { status: this.$route.query.status }
                        })
                    })
                })
                .catch(_ => { })
        },

        // 改价/库存
        async onEditSpu() {
            const config = await this.getSpuConfig()
            this.$refs.packageDialogRef?.open(-1, config, { price: this.goodsDetail?.price, stock: this.goodsDetail?.stock })
        },
        // 更改选中项
        handleSelectionChange(index) {
            this.selectPackageIndex = index
        },
        // 删除套餐
        onRemove(index) {
            if (this.skuList.length === 1) {
                this.$message.warning('请确保至少有一个套餐')
                return
            }
            // 二次确认弹窗
            this.$confirm('确认删除套餐吗？删除后对应套餐历史数据：名称、价格、库存、套餐销量将被清空。', '删除套餐', {
                confirmButtonText: '确定',
                confirmButtonClass: 'confirmButtonClass',
                type: 'warning'
            }).then(() => {
                this.$api.onGeneralGoodsSkuDelete({
                    id: this.skuList[index]?.id
                }).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.$message.success(`套餐【${this.getShortSkuTitle(this.skuList[index]?.skuTitle)}】已删除`)
                    if (this.selectPackageIndex === index) {
                        this.selectPackageIndex = 0
                    }
                    this.getGeneralGoodsSkuDetail()
                })
            })
        },
        /**
         * 获取套餐配置
         */
        async getSkuConfig() {
            if (this.skuConfig?.length) {
                return this.skuConfig
            }
            const res = await this.$api.getPublishGeneralFlowAttrs({ goodsNo: this.goodsNo, bizType: 'SKU' })
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.attrsConfig = res.data || []
            const attrs = this.attrsConfig || []
            const form = []
            const priceFields = {};
            const filterAttrs = attrs.filter(item => {
                if (['unitNumPrice', 'unitPriceNum', 'unit'].includes(item.mappingField)) {
                    priceFields[item.mappingField] = item.valueDefault
                    return false
                }
                return true
            });
            console.log('priceFields====', priceFields);
            filterAttrs.forEach(item => {
                    const { mappingField, propertyName } = item
                    switch (mappingField) {
                        case 'skuTitle':
                        case 'skuStock':
                            form.push({
                                ...item,
                                ruleResult: { display: true, required: true }
                            })
                            break
                        case 'skuPrice':
                            form.push({
                                ...item,
                                ruleResult: { display: true, required: true },
                                priceFields
                            })
                            break
                        case 'unitNum':
                            form.push({
                                ...item,
                                propertyName: `${propertyName} ${priceFields.unit ? `(${priceFields.unit})` : ''}`,
                                ruleResult: { display: true, required: true }
                            })
                            break
                        default:
                            break
                    }
            })
            return form
        },
        async getSpuConfig() {
            if (this.spuConfig?.length) {
                return this.spuConfig
            }
            const res = await this.$api.getPublishGeneralFlowAttrs({ goodsNo: this.goodsNo })
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.attrsConfig = res.data || []
            const attrs = this.attrsConfig || []
            const form = []
            attrs.forEach(item => {
                const { mappingField, propertyName } = item
                switch (mappingField) {
                    case 'price':
                    case 'stock':
                        form.push({
                            ...item,
                            ruleResult: { display: true, required: true }
                        })
                        break
                    default:
                        break
                    }
            })
            return form
        },
        // 编辑套餐
        async editSku(index) {
            const skuDialogData = { ...this.skuList[index] };
            if (skuDialogData.addVerify) {
                this.$message.warning('请审核完成后再编辑')
                return
            };
            const config = await this.getSkuConfig()
            this.$refs.packageDialogRef?.open(index, config, skuDialogData)
        },
        // 更改套餐启用状态
        handleSwitchChange(index) {
            const targetSku = this.skuList[index];
            if (targetSku.master) {
                this.$message.error('主套餐不支持关闭启用状态');
                return;
            }
            this.$api.onGeneralGoodsSkuEnable({
                id: targetSku?.id
            }).then(res => {
                if (!res.success) {
                    this.$message.error(res.info);
                    return
                }
                targetSku.enable = !targetSku.enable
            })
        },
        handlePackageConfirm(data, action) {
            console.log('data====', data, action);
            if (action === 'editSku') {
                const skuData = { ...data };
                delete skuData.feeInfo;
                this.$api.onGeneralGoodsSkuUpdate({
                    ...data
                }).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.$message.success(`套餐【${data.skuTitle}】修改成功`);
                    this.getGeneralGoodsSkuDetail()
                })
            } else if (action === 'addSku') {
                const skuData = { ...data, enable: true, master: false };
                delete skuData.feeInfo;
                this.$api.onGeneralGoodsSkuAdd({
                    goodsNo: this.goodsNo,
                    skuList: [skuData],
                }).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.$message.success(`套餐【${data.skuTitle}】添加成功`);
                    this.getGeneralGoodsSkuDetail()
                })
            } else if (action === 'editSpu') {
                delete data.feeInfo;
                this.$api.onGeneralGoodsPriceUpdate({
                    goodsNo: this.goodsNo,
                    ...data
                }).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.getGeneralGoodsSpuDetail()
                })
            }
        },
        getShortSkuTitle(title) {
            return title.length > 15 ? title.slice(0, 15) + '...' : title
        },
        setMainSku() {
            const targetSet = this.skuList[this.selectPackageIndex]
            // 检查该套餐是否已启用
            if (!targetSet.enable) {
                this.$message.warning('请先启用套餐后再设置为主套餐')
                return
            }

            // 如果点击的是已经是主套餐的套餐，不做任何操作
            if (targetSet.master) {
                this.$message.warning('该套餐已经是主套餐')
                return
            }
            this.$api.onGeneralGoodsSkuSetMaster({
                id: targetSet.id
            }).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.getGeneralGoodsSkuDetail()
            })
        },
        async addSku() {
            const currentIndex = this.skuList?.length || 0
            const config = await this.getSkuConfig()
            this.$refs.packageDialogRef?.open(currentIndex, config)
        },
        copy(text) {
            copyToClip(text, '复制成功')
        }
    }
}
